export default __webpack_public_path__ + "static/media/kaam25.39acda35.jpg";